<template>
  <div>
    <el-tabs type="border-card">
      <el-tab-pane label="司機資料">
        <el-row :gutter="8">
          <el-col :span="12">
            <span>隊編/呼號: {{ vx_driverInfo.driverCallNumber }}</span>
          </el-col>
          <el-col :span="12">
            <span>車號: {{ vx_driverInfo.licence }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <span>狀態: {{ vx_driverInfo.driverStatus }}</span>
          </el-col>
          <el-col :span="12">
            <span>
              車齡:
              {{ carYear }}
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <span>姓名: {{ vx_driverInfo.driverName }}</span>
          </el-col>
          <el-col :span="12">
            <span>性別: {{ vx_driverInfo.gender }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <span>廠牌: {{ vx_driverInfo.carBrand }}</span>
          </el-col>
          <el-col :span="12">
            <span>電話: {{ vx_driverInfo.driverPhoneNumber }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <span>可載人數: {{ vx_driverInfo.availableSeat }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <span>
              聯絡電話1: {{ vx_driverInfo.driverContactPhoneNumber_1 }}
            </span>
          </el-col>
          <el-col :span="12">
            <span>
              聯絡電話2: {{ vx_driverInfo.driverContactPhoneNumber_2 }}
            </span>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="12">
            <span>司機備註: {{ vx_driverInfo.note }}</span>
          </el-col>
          <el-col :span="12">
            <span>服務項目: {{ vx_driverInfo.serviceList }}</span>
          </el-col>
        </el-row>
        <el-row :gutter="8">
          <el-col :span="24">
            <span>更新日期: {{ vx_driverInfo.updatedDate }}</span>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState('hailStateV2', {
      vx_driverInfo: 'driverInfo',
    }),
    carYear() {
      if (this.vx_driverInfo.carYear === undefined || null) return '未填寫'
      if (this.vx_driverInfo.carYear === '未填寫') {
        return this.vx_driverInfo.carYear
      } else {
        if (this.vx_driverInfo.carYear <= 1) {
          return '<1年'
        } else {
          return this.vx_driverInfo.carYear + '年'
        }
      }
    },
  },
}
</script>
<style scoped>
span {
  font-size: 16px;
}

.el-row {
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/pages/hailState/components-v2/DriverInfo.vue